// We need to parse these strings "$1,000.00" into numbers before we can save them in the database.
export const currencyToDecimal = (currencyString: string): number => {
  // Remove all characters except digits and the decimal point
  const numericString = currencyString?.toString().replace(/[^\d.]/g, '');
  // Convert the cleaned string to a number
  return parseFloat(numericString);
};
